// src/com/file_of_report/TempBreakReportDef.js
// 온도관제 레포트 정의
// 운송사는 해당 없음.

import { AppWord, TableColumnType } from "../../value/AppConst";

export const TempBreakReportMeta = {
    instructions: {
        // title: '온도관제 Report(Exp.)',
        headerRowSpan: 2,
        headerRows: [],
        headerBackgroundColor: 'FF66CCFF', // light blue (exceljs)
    },
    // getExtraHeaders: (records) => ValueMisc.makeDurationHeader(records),
};

// width는 8의 배수가 좋아. 40, 48, 56, 64, 72, 80, 88, 96, 104, 112, 120, 128, 136, 144, 152, 160, 168..

// 실질적인 데이터가 없는 경우도 있음.
// 온도관제 레포트
export const TempBreakReportExcelColumns = [
    {
        id: 'gpsDate', width: 96, label: '일자', option:{type:TableColumnType.DATE, align: AppWord.CENTER},
        excel: (row, value) => {
            if(row.gpsDatetime) {
                return row.gpsDatetime.substring(0,10); // "YYYY-MM-DD"
            }
            return '';
        }
    },
    { id: 'storeName', width: 96, label: '도착점포', option:{type:TableColumnType.TEXT} },
    { id: 'vehPlates', width: 96, label: '차량번호', option:{type:TableColumnType.TEXT, align: AppWord.CENTER} },
    {
        id: 'gpsTime', width: 72, label: '시간',
        option:{type:TableColumnType.TEXT, align: AppWord.CENTER},
        excel: (row, value) => {
            if(row.gpsDatetime) {
                return row.gpsDatetime.substring(11,19); // "HH:MM:SS"
            }
            return '';
        }
    },
    { id: 'comName', width: 120, label: '운송사', option:{type:TableColumnType.TEXT} },
    { id: 'tsrTemp', width: 96, label: 'TSR 설정온도', option:{type:TableColumnType.TEXT, align: AppWord.CENTER} },
    {
        id: 'deviation', width: 96, label: '이탈 온도',
        option:{type:TableColumnType.TEXT, align: AppWord.CENTER},
        excel: (row, value) => {
            if(row.resultTemp) {
                let temps = [];
                if(row.resultTemp.includes('전')) {
                    if(row.tempF !== null && row.tempF !== undefined) temps.push(row.tempF);
                }
                if(row.resultTemp.includes('중')) {
                    if(row.tempM !== null && row.tempM !== undefined) temps.push(row.tempM);
                }
                if(row.resultTemp.includes('후')) {
                    if(row.tempR !== null && row.tempR !== undefined) temps.push(row.tempR);
                }
                return temps.map(t => `${t}℃`).join(', ');
            }
            return '';
        }
    },
    { id: 'vehTypeName', width: 104, label: '차종(Ton수)', option:{type:TableColumnType.TEXT} },
    { id: 'transType', width: 88, label: 'WAVE구분', option:{type:TableColumnType.TEXT, align: AppWord.CENTER} },
    {
        id: 'tsrTempF', width: 72, label: '전면',
        option:{type:TableColumnType.TEXT,  align: AppWord.CENTER},
        superHeaders: [{label:'TSR Setting 온도', colSpan:3}]
    },
    {
        id: 'tsrTempM', width: 72, label: '중면',
        option:{type:TableColumnType.TEXT,  align: AppWord.CENTER},
        superHeaders: [null]
    },
    {
        id: 'tsrTempR', width: 72, label: '후면',
        option:{type:TableColumnType.TEXT,  align: AppWord.CENTER},
        superHeaders: [null]
    },
    {
        id: 'resultTemp', width: 96, label: '온도이탈 구역',
        option:{type:TableColumnType.TEXT, align: AppWord.CENTER}
    },
    {
        id: 'arriveTempF', width: 72, label: '전면',
        option:{type:TableColumnType.TEXT,  align: AppWord.CENTER},
        superHeaders: [{label:'점포 도착 온도', colSpan:3}]
    },
    {
        id: 'arriveTempM', width: 72, label: '중면',
        option:{type:TableColumnType.TEXT,  align: AppWord.CENTER},
        superHeaders: [null]
    },
    {
        id: 'arriveTempR', width: 72, label: '후면',
        option:{type:TableColumnType.TEXT,  align: AppWord.CENTER},
        superHeaders: [null]
    },
    { id: 'note', width: 152, label: '비고', option:{type:TableColumnType.TEXT} },
];
